<template>
  <div v-if="fields" class="small-banner pos-rel py-7">
    <div class="content-center">
      <div class="content-constraint text-center pos-rel" style="z-index: 1">
        <h3
          class="h3"
          :class="[
            textColorClass(fields.backgroundColor),
            { 'mb-5': !!fields.button },
          ]"
        >
          <div v-if="fields.title && fields.title.length">
            {{ fields.title }}
          </div>
          <div v-if="fields.titleLine2 && fields.titleLine2.length">
            {{ fields.titleLine2 }}
          </div>
        </h3>
        <ctf-link
          v-if="fields.button"
          :btn-id="fields.button.sys.id"
          :inverted="
            fields.backgroundColor === 'blue' ||
            fields.backgroundColor === 'blue pattern'
          "
        />
      </div>
    </div>
    <div
      :class="[backgroundColorClass(fields.backgroundColor)]"
      class="background"
    />
  </div>
</template>

<script>
import CtfLink from '@/components/snippets/ctf-link'
import { backgroundColorClass, textColorClass } from '@/utils/helpers'

export default {
  name: 'SmallBanner',
  components: {
    CtfLink
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    },
    sliceRefs: {
      type: Object,
      default: null
    }
  },
  methods: {
    backgroundColorClass,
    textColorClass
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";
.background {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
}
</style>
